import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Projects from '../views/Projects.vue'
import SpaceOverview from '../views/SpaceOverview.vue'
import Databases from '../views/Databases.vue'
import DatabaseTables from '../views/DatabaseTables.vue'
import DatabaseQuery from '../views/DatabaseQuery.vue'
import CloudFunctions from '../views/CloudFunctions.vue'
import StorageBuckets from '../views/StorageBuckets.vue'
import StorageFiles from '../views/StorageFiles.vue'
import StaticSites from '../views/StaticSites.vue'
import ApiLogs from '../views/ApiLogs.vue'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/projects'
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/overview',
    name: 'SpaceOverview',
    component: SpaceOverview,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/databases',
    name: 'Databases',
    component: Databases,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/databases/:databaseId/tables',
    name: 'DatabaseTables',
    component: DatabaseTables,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/databases/:databaseId/query',
    name: 'DatabaseQuery',
    component: DatabaseQuery,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/functions',
    name: 'CloudFunctions',
    component: CloudFunctions,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/storage',
    name: 'StorageBuckets',
    component: StorageBuckets,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/storage/:bucketId/files',
    name: 'StorageFiles',
    component: StorageFiles,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/sites',
    name: 'StaticSites',
    component: StaticSites,
    meta: { requiresAuth: true }
  },
  {
    path: '/space/:id/logs',
    name: 'ApiLogs',
    component: ApiLogs,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫，检查登录状态
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = !!Cookies.get('token')
  
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (!requiresAuth && isAuthenticated && to.path === '/login') {
    next('/projects')
  } else {
    next()
  }
})

export default router
